var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("Navigation"),
      _vm._v(" "),
      _c("Header"),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "12" } }, [
            _c(
              "div",
              { class: _vm.style.viewPush },
              [
                _c(
                  "b-overlay",
                  {
                    attrs: {
                      show: _vm.bigLoading,
                      rounded: "sm",
                      "spinner-variant": "warning"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "overlay",
                        fn: function() {
                          return [
                            _c("b-icon", {
                              attrs: {
                                icon: "three-dots",
                                animation: "cylon",
                                scale: "8",
                                variant: "warning"
                              }
                            })
                          ]
                        },
                        proxy: true
                      }
                    ])
                  },
                  [
                    _vm._v(" "),
                    _c(
                      "b-card",
                      { staticClass: "asc__getPage", attrs: { "no-body": "" } },
                      [
                        _c("router-view"),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e0ddbf5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e0ddbf5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/layout/get.vue
// module id = null
// module chunks = 